module.exports = __webpack_public_path__ + "img/result8.a75dcf40.png";